import { BaseException } from './base.exception.js';

export class SerializationException extends BaseException {
  private static readonly ERROR: string = 'Serialization exception';

  constructor(message: string, extraData?: string | object) {
    super(message, extraData);
  }

  public getError(): string {
    return SerializationException.ERROR;
  }
}
